var options = {
  root: null,
  rootMargin: '50%',
  threshold: 0
};

var requestedTab;

// Define changeTab function globally with URL check
window.changeTab = function(tabType) {
  // Don't execute if URL contains '/a/fd/'
  if (window.location.pathname.includes('/a/fd/')) {
    return;
  }

  // Wait for Yotpo to be available and try to change the tab
  if (typeof window.yotpo !== 'undefined' && window.yotpo.initWidgets) {
    // Try to trigger tab change in Yotpo widget
    const tabElement = document.querySelector(`[data-type="${tabType}"]`);
    if (tabElement) {
      tabElement.click();
    }
  } else {
    // If Yotpo isn't loaded yet, try again after a short delay
    setTimeout(() => window.changeTab(tabType), 100);
  }
};


document.addEventListener('DOMContentLoaded', function () {
  var reviewObserver;
  var reviews = document.querySelectorAll('.yotpo-main-widget,[data-review-frame], .yotpo-widget-instance, .yotpo-reviews-carousel');
  requestedTab = window.location.hash;

  // eslint-disable-next-line
  reviewObserver = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        loadReviews();
        reviewObserver.unobserve(entry.target);
      }
    });
  });

  reviews.forEach(function (review) {
    reviewObserver.observe(review, options);
  });
});

function loadReviews() {
  const css = document.createElement('link');
  const script = document.createElement('script');
  css.rel = 'stylesheet';
  css.type = 'text/css';
  css.media = 'all';
  script.type = 'text/javascript';
  script.src = 'https://staticw2.yotpo.com/' + (window.facedr?.yotpoKey || '{{ settings.yotpo_app_key }}') + '/widget.js';

  document.body.appendChild(css);
  document.body.appendChild(script);

  if (requestedTab) {
    changeTab(requestedTab.split('_')[1]);
    requestedTab = null;
  }

  initTabs();
  clearLoader();
}

function clearLoader() {
  const loaders = document.querySelectorAll('[data-review-frame] [data-loader], .yotpo-main-widget [data-loader]');
  const activeTab = document.querySelector('[data-review-frame] .active');

  if (loaders.length > 0) {
    loaders.forEach((loader) => loader.remove());
  }

  if (activeTab !== null) {
    activeTab.classList.remove('hidden');
  }
}

function initTabs() {
  const tabs = document.querySelectorAll('[data-tabs] [data-type], [data-mobile-menu] [data-type]');

  tabs.forEach((tab) => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      changeTab(tab.dataset.type);
    });
  });
}